import { useTranslation } from 'react-i18next';
var Markdown = require('react-remarkable');


const ConfirmationSuccess = ({ uid }) => {
    const { t } = useTranslation();

    var url_discover_more = "https://loropiana.com/";
    var create_wallpaper_button = false;
    var create_timed_redirect = false
    
    // salone mobile 2024
    if (uid === "Salone-Del-Mobile-Montenapoleone") {
        url_discover_more = "https://www.instagram.com/loropiana";
        create_timed_redirect = false
        create_wallpaper_button = false
    }    
    if (uid === "Salone-Del-Mobile-Cortile-Della-Seta") {
        url_discover_more = "https://www.instagram.com/loropiana";
        create_timed_redirect = false
        create_wallpaper_button = false
    }  
    // resort 2024
    if (uid === "Resort-2024-Milano") {
        url_discover_more = "https://it.loropiana.com/it/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Forte-Dei-Marmi") {
        url_discover_more = "https://it.loropiana.com/it/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-St-Tropez") {
        url_discover_more = "https://fr.loropiana.com/fr/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Okinawa") {
        url_discover_more = "https://jp.loropiana.com/ja/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Ginza-Matsuya") {
        url_discover_more = "https://jp.loropiana.com/ja/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Chengdu-Taikoo-Li") {
        url_discover_more = "https://www.loropiana.cn/landing-page/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Shanghai-IFC") {
        url_discover_more = "https://www.loropiana.cn/landing-page/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Hong-Kong-IFC") {
        url_discover_more = "https://hk.loropiana.com/zh_HK/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Bangkok-Siam-Paragon") {
        url_discover_more = "https://ii.loropiana.com/en/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }
    if (uid === "Resort-2024-Shinsegae-Gangnam") {
        url_discover_more = "https://kr.loropiana.com/ko/resort-collection";
        create_timed_redirect = false
        create_wallpaper_button = true
    }

    // automatic redirect after 2 seconds
    if (create_timed_redirect) {
        setTimeout(function () { window.location.href = 'https://loropiana.com/'; }, 2000);
    }

    if (create_wallpaper_button) {
        return (
            <div className='container'>

                <div className="alert my-1" role="alert" style={{ paddingTop: '40px' }}>
                    <h4><Markdown>{t("double_opt_in_success")}</Markdown></h4>
                </div>

                <div className="alert my-1" role="alert">
                    <h5><Markdown>{t("thank_description_1")}</Markdown></h5>
                </div>

                <div className="d-flex flex-row justify-content-center" >
                    <div className="m-4">
                        <a className="btn btn-loropiana btn-optima" href={url_discover_more}>{t("discover_more")}</a>
                    </div>
                </div>

                <div className="alert my-1" role="alert" style={{ paddingBottom: '0px', marginBottom: '0px', paddingTop: "20px" }}>
                    <h6><Markdown>{t("download_wallpaper")}</Markdown></h6>
                </div>

                <div className="row justify-content-center" style={{ paddingBottom: '15px' }} >
                    <div className="col-sm-2 col-4">
                        <a href="/assets/wallpaper/wallpaper-1.jpg" download="loropiana-wallpaper-1.jpg">
                            <img class="img-fluid" src='/assets/wallpaper/wallpaper-1-thumbnail.jpg' />
                        </a>
                    </div>
                    <div className="col-sm-2 col-4" >
                        <a href="/assets/wallpaper/wallpaper-2.jpg" download="loropiana-wallpaper-2.jpg">
                            <img class="img-fluid" src='/assets/wallpaper/wallpaper-2-thumbnail.jpg' />
                        </a>
                    </div>
                </div>

            </div >
        );
    } else {
        return (
            <div className='container'>
                <div className="alert my-5" role="alert">
                    <h4><Markdown>{t("double_opt_in_success")}</Markdown></h4>
                </div>
                <div className="d-flex flex-row justify-content-center">
                    <div className="m-4">
                        <a className="btn btn-loropiana btn-optima" href={url_discover_more}>{t("discover_more")}</a>
                    </div>
                </div>
            </div>
        );
    };
}

export default ConfirmationSuccess;